function parseDt(value) {
    if (!value) return null;
    const d = new Date(String(value).replace(' ', 'T'));
    return Number.isNaN(d.getTime()) ? null : d;
}

// Фаза задания выводится из дат (статуса у задания нет):
// availableFrom в будущем → запланировано; availableUntil прошёл → приём закрыт; иначе — идёт приём.
export function taskPhase(task, now = new Date()) {
    const from = parseDt(task.availableFrom);
    const until = parseDt(task.availableUntil);
    if (from && from > now) {
        const pad = (n) => String(n).padStart(2, '0');
        return { label: `Запланировано (с ${pad(from.getDate())}.${pad(from.getMonth() + 1)})`, tone: 'planned' };
    }
    if (until && until < now) return { label: 'Приём закрыт', tone: 'closed' };
    return { label: 'Идёт приём', tone: 'open' };
}

// Статусы сдачи: фильтр очереди модерации.
export const SUBMISSION_FILTERS = Object.freeze([
    { value: 'PENDING', label: 'На проверке' },
    { value: 'APPROVED', label: 'Подтверждённые' },
    { value: 'REJECTED', label: 'Отклонённые' }
]);

// Бэкенд отдаёт даты как "2026-07-18 14:30:00" или ISO "2026-07-18T14:30:00".
export function formatDt(value) {
    if (!value) return '—';
    const d = new Date(String(value).replace(' ', 'T'));
    if (Number.isNaN(d.getTime())) return String(value);
    const pad = (n) => String(n).padStart(2, '0');
    return `${pad(d.getDate())}.${pad(d.getMonth() + 1)} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

// "2026-07-18T14:30:00" → значение для input[type=datetime-local].
export function toLocalInput(value) {
    if (!value) return '';
    return String(value).replace(' ', 'T').slice(0, 16);
}

// Значение datetime-local → LocalDateTime бэкенда.
export function toApiDateTime(value) {
    return value ? `${value}:00` : null;
}
